export default {
  // 课程
  competitionCourseList: '/competition_course/list',
  competitionCourseDetail: '/competition_course/detail',
  competitionCourseNextFilter: '/competition_course/next-filter',
  competitionCourseRollbackFilter: '/competition_course/rollback-filter',

  // 评价
  competitionCourseCommentList: '/competition_course_comment/list',
  competitionCourseCommentDetail: '/competition_course_comment/detail',
  competitionCourseCommentStore: '/competition_course_comment/store',
  competitionCourseCommentUpdate: '/competition_course_comment/update',


}